import React, { useState } from "react";
import AmpInput from "./AmpInput";

import { useTranslation } from "react-i18next";
import AmpToolTip from "../AmpToolTip/AmpToolTip";
import "./RollNumberInput.css";

interface RollNumberInputProps {
    onChange?: (e: string) => void;
    noPlaceHolder?: boolean;
    showTooltip?: boolean;
}

export default function RollNumberInput(props: RollNumberInputProps): JSX.Element {
    const { t } = useTranslation('login');
    
    const [roll1, setRoll1] = useState("");
    const [roll2, setRoll2] = useState("");
    const [roll3, setRoll3] = useState("");
    const [roll4, setRoll4] = useState("");
    const [roll5, setRoll5] = useState("");
    const [roll6, setRoll6] = useState(props.noPlaceHolder ? "" : "0000");

    const onPaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
        e.preventDefault();
        const pastedRoll = e.clipboardData.getData('text').trim().replace(/\s/g, '');
        if (/^\d+$/.test(pastedRoll)) {
            const roll1Content = pastedRoll.substring(0, 2);
            setRoll1(roll1Content);
            const roll2Content = pastedRoll.substring(2, 4)
            setRoll2(roll2Content);
            const roll3Content = pastedRoll.substring(4, 7);
            setRoll3(roll3Content);
            const roll4Content = pastedRoll.substring(7, 10);
            setRoll4(roll4Content);
            const roll5Content = pastedRoll.substring(10, 15)
            setRoll5(roll5Content);
            let roll6Content = pastedRoll.substring(15, 19);
            roll6Content = roll6Content + "0".repeat(4 - roll6Content.length);
            setRoll6(roll6Content);
            if (typeof props.onChange === "function") {
                props.onChange(roll1Content + roll2Content + roll3Content + roll4Content + roll5Content + roll6Content);
            }
        }
    }

    const validateInput1 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 2);
        e.currentTarget.value = inputValue;
        setRoll1(inputValue);
        if (inputValue.length === 2) {
            (e.currentTarget.nextElementSibling as HTMLInputElement).focus();
        }
        if (typeof props.onChange === "function") {
            props.onChange(inputValue + roll2 + roll3 + roll4 + roll5 + roll6);
        }
    }
    const validateInput2 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 2);
        e.currentTarget.value = inputValue;
        setRoll2(inputValue);
        if (inputValue.length === 2) {
            (e.currentTarget.nextElementSibling as HTMLInputElement).focus();
        }
        if (typeof props.onChange === "function") {
            props.onChange(roll1 + inputValue + roll3 + roll4 + roll5 + roll6);
        }
    }
    const validateInput3 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 3);
        e.currentTarget.value = inputValue;
        setRoll3(inputValue);
        if (inputValue.length === 3) {
            (e.currentTarget.nextElementSibling as HTMLInputElement).focus();
        }
        if (typeof props.onChange === "function") {
            props.onChange(roll1 + roll2 + inputValue + roll4 + roll5 + roll6);
        }
    }
    const validateInput4 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 3);
        e.currentTarget.value = inputValue;
        setRoll4(inputValue);
        if (inputValue.length === 3) {
            (e.currentTarget.nextElementSibling as HTMLInputElement).focus();
        }
        if (typeof props.onChange === "function") {
            props.onChange(roll1 + roll2 + roll3 + inputValue + roll5 + roll6);
        }
    }
    const validateInput5 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 5);
        e.currentTarget.value = inputValue;
        setRoll5(inputValue);
        if (inputValue.length === 5) {
            const nextInputElement = e.currentTarget.nextElementSibling as HTMLInputElement;
            nextInputElement.focus();
            nextInputElement.select();
        }
        if (typeof props.onChange === "function") {
            props.onChange(roll1 + roll2 + roll3 + roll4 + inputValue + roll6);
        }
    }
    const validateInput6 = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.currentTarget.value.replace(/[^0-9]+/g, '').substring(0, 4);
        e.currentTarget.value = inputValue;
        setRoll6(inputValue);
        if (typeof props.onChange === "function") {
            props.onChange(roll1 + roll2 + roll3 + roll4 + roll5 + inputValue);
        }
    }

    return (
        <fieldset className="roll-inputs" onPaste={(e) => onPaste(e)}>
            <legend className="heading-small">
                {t('roll-num') as string} {props.showTooltip && <AmpToolTip id="rollTooltip" content={t("roll-tip") as string} direction="right"/>}
            </legend>
            <div>
                <AmpInput name="roll_part1" id="roll_part1" type="text" label="roll_part1" ariaLabel="roll_part1" value={roll1} maxLength={2} onChange={validateInput1} />
                <AmpInput name="roll_part2" id="roll_part2" type="text" label="roll_part2" ariaLabel="roll_part2" value={roll2} maxLength={2} onChange={validateInput2} />
                <AmpInput name="roll_part3" id="roll_part3" type="text" label="roll_part3" ariaLabel="roll_part3" value={roll3} maxLength={3} onChange={validateInput3} />
                <AmpInput name="roll_part4" id="roll_part4" type="text" label="roll_part4" ariaLabel="roll_part4" value={roll4} maxLength={3} onChange={validateInput4} />
                <AmpInput name="roll_part5" id="roll_part5" type="text" label="roll_part5" ariaLabel="roll_part5" value={roll5} maxLength={5} onChange={validateInput5} />
                <AmpInput name="roll_part6" id="roll_part6" type="text" label="roll_part6" ariaLabel="roll_part6" value={roll6} maxLength={4} onChange={validateInput6} />
            </div>
        </fieldset>

    )
}